<template>
    <div class="d-flex align--center justify--space-between">
        <button class="btn btn-sm btn btn-info" type="submit" @click="$emit('click')">
            Buscar
        </button>
    </div>
</template>

<script>
    export default {
        name: "BtnSugerido"
    }
</script>

<style scoped>

</style>
